import { HelpIconTooltip } from "@components/common/help-icon-tooltip";
import { Box } from "@mui-wrapper";

interface Props {
  /** The content to show when hovering over the question mark icon */
  helpTitle: React.ReactNode;
  /** The action, usually a button, that the question mark explains */
  children: React.ReactNode;
}

/**
 * Shows a question mark to the right of an action without moving the action, so that it stays
 * aligned with the other actions of the column.
 */
export function ActionWithHelp({
  helpTitle,
  children,
}: Props): React.JSX.Element {
  return (
    <Box sx={{ position: "relative", width: "fit-content" }}>
      {children}

      <Box
        sx={{
          position: "absolute",
          left: "100%",
          top: "50%",
          transform: "translateY(-50%)",
          ml: 1,
          display: "flex",
        }}
      >
        <HelpIconTooltip title={helpTitle} />
      </Box>
    </Box>
  );
}
